import { IAppState } from '../common/state';
import { isCommercial, offerTypeFromJsonQuery } from '../utils/category';

export function isFiltersRedesignExperimentEnabled(state: IAppState) {
  return !isCommercial(offerTypeFromJsonQuery(state.results.jsonQuery)) && state.isFiltersRedesignEnabled;
}
